import { registerSW } from 'virtual:pwa-register';

/**
 * Register the service worker generated by vite-plugin-pwa.
 * With registerType: 'autoUpdate', the SW updates silently in the background.
 */
export const updateSW = registerSW({
  onRegisteredSW(swUrl, registration) {
    // Check for SW updates every hour
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000);
    }
  },
  onOfflineReady() {
    console.log('[PWA] App ready to work offline');
  },
});
